import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuspendComponent } from './suspend.component';

@NgModule({
  declarations: [
    SuspendComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SuspendComponent
  ]
})
export class SuspendModule { }
export { SuspendComponent };